import type { ReactNode } from "react";
import "./ScheduleAlertRow.scss";
import type { ScheduleAlert } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlert.ts";
import { employeeScheduleRowId } from "@/pages/human-resources/time-management/schedules/site-schedule/day-view/schedule-rows/employee-schedule/EmployeeScheduleRowId.ts";
import { useTranslation } from "react-i18next";
import flashElementById from "@/shared/style/flashElementById.ts";

interface Properties {
  alert: ScheduleAlert;
  revealEmployeeId: (id: string) => boolean;
}

export default function ScheduleAlertRow(props: Properties): ReactNode {
  const { t } = useTranslation(["common"]);
  const employeeRowElementId = employeeScheduleRowId(props.alert.employeeId);
  const flashLevel = props.alert.level === "BLOCKING" ? "error" : "warning";

  return (
    <div className="schedule-alert-row">
      <div dangerouslySetInnerHTML={{ __html: props.alert.htmlMessage }}></div>
      <div className="see-link">
        <span
          onClick={() => {
            setTimeout(
              () => {
                flashElementById(employeeRowElementId, flashLevel);
              },
              props.revealEmployeeId(props.alert.employeeId) ? 100 : 0,
            );
          }}
        >
          {t("common:actions.see")}
        </span>
      </div>
    </div>
  );
}
